import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const ChatUnreadMessagesInfo: React.VFC = () => {
  return (
    <div className={styles['container']} data-testid="chat_unread_messages_info">
      <UIText3 color="black_60">Непрочитанные сообщения</UIText3>
    </div>
  );
};
